import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Stars } from "@/components/Reviews";

const BADGE = { pending: "bg-amber-100 text-amber-800", approved: "bg-emerald-100 text-emerald-800", hidden: "bg-slate-200 text-slate-700" };

export function ReviewsTab() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("pending");
  const load = useCallback(() => api.get("/admin/reviews", { params: filter === "all" ? {} : { status: filter } }).then((r) => setRows(r.data)), [filter]);
  useEffect(() => { load(); }, [load]);
  const mark = async (id, status) => { await api.patch(`/admin/reviews/${id}`, { status }); toast.success(`Review ${status}`); load(); };

  return (
    <div className="mt-4">
      <Select value={filter} onValueChange={setFilter}>
        <SelectTrigger className="w-44 mb-3" data-testid="admin-review-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          {["pending", "approved", "hidden", "all"].map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
      <div className="bg-white rounded-xl border border-gold/15 divide-y">
        {rows.length === 0 && <div className="p-8 text-center text-indigo-deep/60">No reviews</div>}
        {rows.map((r) => (
          <div key={r.id} data-testid={`admin-review-${r.id}`} className="p-3 flex justify-between gap-3 text-sm">
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2"><Stars value={r.rating} size="w-3.5 h-3.5" /><span className="font-semibold text-indigo-deep">{r.entity_name}</span></div>
              <div className="text-xs text-indigo-deep/60">{r.user_name} · {new Date(r.created_at).toLocaleString()}</div>
              {r.title && <div className="font-medium text-indigo-deep mt-1">{r.title}</div>}
              {r.body && <div className="text-xs text-indigo-deep/70 mt-0.5">{r.body}</div>}
            </div>
            <div className="flex flex-col items-end gap-1 shrink-0">
              <span className={`text-[10px] uppercase font-semibold px-2 py-0.5 rounded-full ${BADGE[r.status]}`}>{r.status}</span>
              <div className="flex gap-1">
                {r.status !== "approved" && <Button size="sm" variant="ghost" data-testid={`approve-${r.id}`} onClick={() => mark(r.id, "approved")} className="text-emerald-700">Approve</Button>}
                {r.status !== "hidden" && <Button size="sm" variant="ghost" data-testid={`hide-${r.id}`} onClick={() => mark(r.id, "hidden")} className="text-red-600">Hide</Button>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
